export default __webpack_public_path__ + "static/media/money-back@2x.bcc3ab98.png";